import API from '../api'
import convertPagableData from '../convertPagableData'
import getUrl from './paths'

export const getOrganisation = (orgId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getOrganisation, { orgId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getAllOrganisations = (page = 0, size = 10, orgFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllOrganisations, { page, size, ...orgFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getAllOrganisationsV2 = (page = 0, size = 10, orgFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllOrganisationsV2, { page, size, ...orgFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getOrganisationByUser = (userId) =>
	new Promise((resolve, reject) =>
		API.get(getUrl.getOrganisationByUser, { userId, removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	)

export const getAllOrgLocations = (orgRole) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllOrganisationLocations, { orgRole })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getAllLogisticPartners = () =>
	new Promise((resolve, reject) =>
		API.get(getUrl.getAllLogisticPartners)
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	)

export const getUsersOfOrganisation = (organisationId, userId) =>
	new Promise((resolve, reject) =>
		API.get(getUrl.getUsersOfOrganisation, { organisationId, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	)

export const getAllAccountDetails = (organisationId, userId) =>
	new Promise((resolve, reject) =>
		API.get(getUrl.getAllAccountDetails, { organisationId, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	)

// Bank accounts attached to one GST number. `removeDefault` keeps the API layer from adding its
// usual userId / organisationId / size params — this endpoint only takes `gst`.
export const getAccountDetailsByGst = (gst) =>
	new Promise((resolve, reject) =>
		API.get(getUrl.getAccountDetailsByGst, { gst, removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	)

export const getOrganisationKycData = (organisationId) =>
	new Promise((resolve, reject) =>
		API.get(getUrl.getOrganisationKycData, { organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	)

export const getSubsidiaries = (orgId) =>
	new Promise((resolve, reject) =>
		API.get(getUrl.getSubsidiaries, { orgId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	)

export const getLedgersOfUser = (organisationId, page = 0, orgFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getLedgersOfUser, { organisationId, page, ...orgFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})
export const getLedgerSummaryByOrgId = (organisationId, ledgerFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getLedgerSummaryByOrgId, { organisationId, ...ledgerFilters })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getPanByCompanyName = (companyName) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getPanByCompanyName, { companyName })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getWarehouseAddress = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getOrgWarehouses, { organisationId, removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

// orderGiven narrows the list to clients that actually have an order placed. Optional, so
// existing callers keep the full list.
export const getAllClientsApi = (userId, commodityFilter, orderGiven) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllClients, {
			userId,
			...(commodityFilter ? { commodityFilter } : {}),
			...(orderGiven != null ? { orderGiven } : {}),
		})
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getManufacturersLocation = () =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getManufacturerLocations, { removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getOrganisationCreditDetails = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getOrganisationCreditDetails, { organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getProjectCodes = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProjectCodes, { organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
